import LateIcon from "@fragments/LateIcon.component";
import type React from "react";
import styles from "./StatusGantt.module.scss";

export type StatusGanttVariantType =
  | "error"
  | "not-executed"
  | "completed"
  | "completed-late"
  | "not-started"
  | "in-progress"
  | "awaiting-end"
  | "awaiting-justification";

export interface StatusGanttProps {
  variant: StatusGanttVariantType;
  showLateIcon?: boolean;
  size?: "default" | "large";
}

const StatusGantt: React.FC<React.PropsWithChildren<StatusGanttProps>> = ({
  variant,
  showLateIcon = false,
  size = "default",
  children,
}) => {
  return (
    <div className={`${styles.container} ${styles[size]}`}>
      <div className={`${styles.status} ${styles[variant]}`}>{children}</div>

      {showLateIcon && <LateIcon size={size === "large" ? "lg" : "xsm"} />}
    </div>
  );
};

export default StatusGantt;
